// extracted by mini-css-extract-plugin
export default {"tabContainerCard":"BHX5rLN3CYXEcWIfog27","secendHead":"d3iwY43KRpo9_sNvwRlx","buttonTabAdd":"WkZUme7W2O0mRPQlhjHh"};